import _ from "lodash";
import { BASE_URL } from "@/env";
import { Flex, Typography } from "antd";
import { useCallback, useEffect, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const getJWT = async (code: string) => {
    try {
        const formData = {
            "code": code,
        };
        const res = await fetch(`${BASE_URL}/get-jwt`,
            {
                method: "POST",
                body: JSON.stringify(formData),
            }
        ).then(async r => {
            return r.clone().json();
        });
        return res;
    } catch (error) {
        console.log(error)
        throw error;
    }
};

const RedirectSSO: React.FC = () => {
    const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams();


    // const code = _.defaultTo(queryString.get("code"), "");

    const clearSession = useCallback(async () => {
        navigate('/', { replace: true });
    }, [navigate]);

    const handleAuthorization = useCallback(async (callback: () => void) => {
        try {
            const code = searchParams.get("code") ?? ""
            console.log(code)
            const jwtResult: any = await getJWT(code);
            console.log("jwtResult.data.token")
            console.log(jwtResult.data.token)

            if (jwtResult.code != 200) {
                clearSession();
                return;
            } else {
                console.log(jwtResult.data.token)
                await localStorage.setItem("token", jwtResult.data.token);
            }
        } catch (error) {
            clearSession()
        }
        var timerId = setTimeout(() => {
            navigate("/authen");
        }, 2000);

        return () => clearTimeout(timerId);
    }, [clearSession]);

    useEffect(() => {
        handleAuthorization(() => { });
    }, []);

    return (
        <Flex gap="middle" align="center" vertical>
            <Typography.Text style={{ fontSize: 24, color: "#40C1A2" }}>
                Verifying...
            </Typography.Text>
        </Flex>
    );
};

export default RedirectSSO;
